<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filter" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Unit Id</mat-label>
          <input placeholder="Unit Id"
            matInput
            [matChipInputFor]="chipUnitId"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
          </mat-form-field>
          <mat-chip-grid #chipUnitId>
            @for (item of unitIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'unitids')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>

        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Branch Number</mat-label>
            <input placeholder="Branch Number"
              matInput
              [matChipInputFor]="chipBranchNumbers"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'branchnumbers')">
            </mat-form-field>
            <mat-chip-grid #chipBranchNumbers>
              @for (item of branchNumbers; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'branchnumbers')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>

          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Controller Type</mat-label>
              <input placeholder="Controller Type"
                matInput
                [matChipInputFor]="chipControllerTypes"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'controllertypes')">
              </mat-form-field>
              <mat-chip-grid #chipControllerTypes>
                @for (item of controllerTypes; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'controllertypes')">
                    {{item}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-field">
              <mat-form-field class="search-input">
                <mat-label>Escalator Controller Type</mat-label>
                <input placeholder="Controller Type"
                  matInput
                  [matChipInputFor]="chipEscalatorControllerTypes"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event, 'escalatorcontrollertypes')">
                </mat-form-field>
                <mat-chip-grid #chipEscalatorControllerTypes>
                  @for (item of escalatorControllerTypes; track item) {
                    <mat-chip-row
                      [removable]="removable" (removed)="remove(item, 'escalatorcontrollertypes')">
                      {{item}}
                      @if (removable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip-row>
                  }
                </mat-chip-grid>
              </div>
              <div class="filter-actions">
                <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                  {{ changeTypeButton() ? 'Reset' : 'Filter' }}
                </button>
              </div>
            </form>
          </mat-expansion-panel>
        </mat-accordion>